import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Sidebar, Segment, Menu, Icon } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { ActionCable } from 'react-actioncable-provider';

import {
  completedLibraryControlTranslation,
  failedLibraryControlTranslation,
  pendingLibraryControlTranslation
} from '../../actions/library_control';
import * as paths from '../../constants'
import history from '../../history'
import SystemHeader from '../../components/system_header'
import Feedback from '../../components/feedback'
import ControlInventoryTable from './table'
import { getTranslations } from '../../actions/language'
import { logOutToken } from '../../actions/app_token'
import { getText } from '../../helpers';
import ObjectITButton from '../../components/developed_by_objectit';

import 'semantic-ui-css/semantic.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import '../../App.css';

const TRANSLATION_TIMEOUT = 2 * 60 * 1000;

class LibraryControls extends Component {
  constructor(props){
    super(props);
    this.state = {
      sidebarShown: false,
      language: props.language,
      languages: props.languages,
      translations: props.language.translations,
      languageName: props.language.name,
    }
    this.translationTimeouts = [];
  }

  componentWillMount = () => {
    if (!this.props.signedIn){
      return history.push(paths.LOGIN_PATH)
    }

    this.removePendingTranslations()
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.language !== this.props.language){
      this.setState({
        language: nextProps.language,
        languages: nextProps.languages,
        translations: nextProps.language.translations,
        languageName: nextProps.language.name,
      })
    }
    
  };

  removePendingTranslations = () => {
    // cleanup pending translations incase we fail to recieve completion event via actioncable
    const pendingTranslations = this.props.library_control.pendingTranslations;

    if(pendingTranslations && pendingTranslations.length > 0) {
      const currentTimestamp = Date.now();

      pendingTranslations.forEach(({ timestamp, library_control, type }) => {
        if(type !== "failed_translation") {
          const timestampDiff = currentTimestamp - timestamp;

          if(timestampDiff >= TRANSLATION_TIMEOUT) {
            this.props.completedLibraryControlTranslation(library_control);
          } else {
            setTimeout(() => this.props.completedLibraryControlTranslation(library_control), timestampDiff)
          }
        }
      });
    }
  }

  showSideBar = () => {
    this.setState({ sidebarShown: true })
  }

  hideSideBar = () => {
    if (this.state.sidebarShown) {
      this.setState({ sidebarShown: false })
    }
  }

  libraryControlChannelListener = (event) => {
    if(!event.library_control) return;
    
    const timeoutIndex = this.translationTimeouts.findIndex(({ custom_id }) => custom_id === event.library_control.custom_id);

    if(timeoutIndex >= 0) {
      clearTimeout(this.translationTimeouts[timeoutIndex].timeout);
      this.translationTimeouts.splice(timeoutIndex, 1);
    }
  
    if (event.type === "pending_translation") {
      this.props.pendingLibraryControlTranslation(event.library_control)
      // this timeout will make sure to remove current control from pending translation
      // incase of completed_translation is not received for some reasons after the translation has timed out.
      const timeout = setTimeout(() => {
        this.props.completedLibraryControlTranslation(event.library_control);
      }, TRANSLATION_TIMEOUT)
      this.translationTimeouts.push({ timeout, custom_id: event.library_control.custom_id })
    } else if (event.type === "completed_translation") {
      this.props.completedLibraryControlTranslation(event.library_control)
    } else if (event.type === "failed_translation") {
      this.props.failedLibraryControlTranslation(event.library_control)
    }
  }

  render() {
    const { sidebarShown } = this.state;
    const { features } = this.props.instanceConfig
    const isEnabledTranslations = features && features.ai_translation

    return (
      <div className="App">
        <ActionCable channel={{ channel: 'LibraryControlChannel' }} onReceived={this.libraryControlChannelListener} />
        <Sidebar.Pushable as={Segment}>
          <Sidebar
            as={Menu}
            animation='overlay'
            width='thin'
            visible={sidebarShown}
            icon='labeled'
            vertical
            inverted
            onMouseLeave={() => this.hideSideBar()}
          >
            <Menu.Item name='home' as={Link} to={paths.DASHBOARD_PATH + '/risk_templates'}>
              <span className="sidebar-button-wrap"><Icon name='file alternate'></Icon><div>{getText('Edit Template')}</div></span>
            </Menu.Item>            
            <Menu.Item name='plans' as={Link} to={paths.DASHBOARD_PATH + '/risk_plans'}>
              <span className="sidebar-button-wrap"><Icon name='file alternate'></Icon><div>{getText('Open Plan')}</div></span>
            </Menu.Item>
            <Menu.Item className='selected' as={Link} to={paths.LIBRARY_CONTROLS_PATH}>
              <span className="sidebar-button-wrap"><Icon name='file'></Icon><div>{getText('Control Library')}</div></span>
            </Menu.Item>
            <Menu.Item name='users' as={Link} to={paths.USERS_PATH}>
              <span className="sidebar-button-wrap"><Icon name='users'></Icon><div>{getText('Manage Users')}</div></span>
            </Menu.Item>
            <Menu.Item name='send_feedback' onClick={()=>{}}>
              <span className="sidebar-button-wrap"><Feedback translations={this.state.translations}/></span>
            </Menu.Item>
            <Menu.Item>
              <ObjectITButton />
            </Menu.Item>
          </Sidebar>
          <Sidebar.Pusher>
            <Segment basic>
              <SystemHeader
                toggleSideBar={this.showSideBar}
                notifications={this.state.notifications}
                pendingMessage={this.state.pendingMessage}
                showLogout={true}
                view='control-library'
                showMenuButton={true}
                showLanguage={isEnabledTranslations}
              />
              <div className="control-inventory-table">
                <ControlInventoryTable/>
              </div>
            </Segment>
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.app_token.accessToken,
    signedIn: state.app_token.signedIn,
    isAdmin: state.app_token.isAdmin,
    language: state.language.language,
    languages: state.language.languages,
    planTags: state.plan.planTags,
    instanceConfig: state.instance.instanceConfig,
    library_control: state.library_control,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    logout: (token) => {
      dispatch(logOutToken(token))
    },
    getTranslations: (name) => {
      dispatch(getTranslations(name))
    },
    pendingLibraryControlTranslation: (library_control) => {
      dispatch(pendingLibraryControlTranslation(library_control))
    },
    completedLibraryControlTranslation: (library_control) => {
      dispatch(completedLibraryControlTranslation(library_control, "all"))
    },
    failedLibraryControlTranslation: (library_control) => {
      dispatch(failedLibraryControlTranslation(library_control))
    }
  }
}

let LibraryControlsPage = connect(mapStateToProps, mapDispatchToProps)(LibraryControls)
export default LibraryControlsPage;



// WEBPACK FOOTER //
// ./src/views/control_library/index.js